import { getColor } from "views/resources/theme";
import styled from "styled-components";

export const Image = styled.div`
	display: flex;
	justify-content: "center";
	background: ${getColor("bg")};
	img {
		height: 48px;
		width: 48px;
		border-radius: 4px;
		background-color: #ffffff;
		box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.27);
	}
`;

export const BigImage = styled.div`
	display: flex;
	justify-content: "center";
	background: ${getColor("bg")};
	img {
		height: 124px;
		width: 124px;
		border-radius: 4px;
		background-color: #ffffff;
		box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.27);
	}
`;

export { default as Filter } from "./Filter.jsx";
export { default as Button } from "./Button";
export { default as LoginButton } from "./LoginButton";
export { default as NextButton } from "./NextButton";
export { default as AtrasButton } from "./AtrasButton";
export { default as Tag } from "./Tag";
export { default as Drawer } from "./Drawer";
export { default as DatePicker } from "./DatePicker";
export { default as Content } from "./Content";
export { default as Spinner } from "./Spinner";
